import { Swiper } from "swiper/swiper-react";
import { Box, IconButton, Stack } from "@mui/material";
import { styled } from "@mui/system";
import { BOX_SHADOWS } from "@shared/styles";

export const GroupsSwiper = styled(Swiper)({
    overflow: "visible",
    "@media (min-width: 640px)": {
        overflow: "hidden",
    },
    ".swiper-button-disabled": {
        color: "transparent",
    },
    ".swiper-button-prev:after": {
        content: "none",
    },
    ".swiper-button-next:after": {
        content: "none",
    },
    "& .swiper-pagination.swiper-pagination": {
        bottom: "-32px",
    },
    "& .swiper-pagination .swiper-pagination-bullet-active": {
        backgroundColor: "var(--community-color-snow-white)",
    },
});

export const ArrowIconButton = styled(IconButton)({
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: "20px",
    width: "40px",
    height: "40px",
    ...BOX_SHADOWS.ELEVATION_3,
    "&:hover": {
        backgroundColor: "var(--community-color-snow-white)",
    },
    svg: {
        width: "16px",
        height: "16px",
    },
});

export const SwiperContainer = styled(Box)({
    padding: "16px 16px 38px 16px",
    margin: "-16px",
    overflow: "hidden",
});

export const VideoPreviewBox = styled(Box)({
    maxHeight: "80vh",
    display: "flex",
    borderRadius: "12px",
    position: "relative",
    img: {
        objectFit: "cover",
        aspectRatio: "2/3",
        width: "100%",
        height: "auto",
        borderRadius: "12px",
    },
});

export const PlayVideoIconButton = styled(IconButton)({
    width: "40px",
    height: "40px",
    border: "2px solid var(--community-color-snow-white)",
    position: "absolute",
    bottom: 12,
    left: 12,
    padding: 0,
    backgroundColor: "var(--community-color-transparent-black-05)",
    svg: {
        width: "20px",
        height: "20px",
        color: "var(--community-color-snow-white)",
    },
});

export const ActionButtonsContainer = styled(Stack)({
    position: "absolute",
    bottom: 12,
    right: 12,
    gap: 8,
});

export const ActionIconBox = styled(Box)({
    color: "var(--community-color-snow-white)",
    padding: 0,
    fontSize: "14px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    svg: {
        width: "24px",
        height: "24px",
        color: "var(--community-color-snow-white)",
    },
});
